import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { defaultEmojiHeight, SAMPLING_RATE_EMOJI_RENDERED_EXP } from '../../util/constants';
import EmojiPlaceholder from './EmojiPlaceholder';
import LoadingEmojiComponent from './LoadingEmojiComponent';
import { sampledUfoRenderedEmoji, ufoExperiences } from '../../util/analytics';
import { UfoErrorBoundary } from './UfoErrorBoundary';

const resourcedEmojiModuleLoader = () => import(
/* webpackChunkName:"@atlaskit-internal_resourcedEmojiComponent" */
'./ResourcedEmojiComponent');

const resourcedEmojiComponentLoader = () => resourcedEmojiModuleLoader().then(module => module.ResourcedEmojiComponent);

export default class ResourcedEmoji extends LoadingEmojiComponent {
  // state initialised with static component to prevent
  // rerender when the module has already been loaded
  constructor(props) {
    super(props, {});

    _defineProperty(this, "state", {
      asyncLoadedComponent: ResourcedEmoji.AsyncLoadedComponent
    });

    sampledUfoRenderedEmoji(props.emojiId).start({
      samplingRate: SAMPLING_RATE_EMOJI_RENDERED_EXP
    });
    ufoExperiences['emoji-rendered'].getInstance(props.emojiId.id || props.emojiId.shortName).addMetadata({
      source: 'resourced-emoji',
      emoji: props.emojiId.shortName
    });
  }

  componentWillUnmount() {
    sampledUfoRenderedEmoji(this.props.emojiId).abort({
      metadata: {
        source: 'ResourcedEmoji',
        reason: 'unmount',
        data: {
          emojiId: this.props.emojiId.id,
          shortName: this.props.emojiId.shortName
        }
      }
    });
  }

  asyncLoadComponent() {
    resourcedEmojiComponentLoader().then(component => {
      ResourcedEmoji.AsyncLoadedComponent = component;
      this.setAsyncState(component);
    });
  }

  renderLoading() {
    const {
      fitToHeight,
      emojiId,
      showTooltip
    } = this.props;
    return /*#__PURE__*/React.createElement(EmojiPlaceholder, {
      shortName: emojiId.shortName,
      showTooltip: showTooltip,
      size: fitToHeight || defaultEmojiHeight
    });
  }

  renderLoaded(loadedEmojiProvider, ResourcedEmojiComponent) {
    const {
      emojiProvider,
      ...otherProps
    } = this.props;
    return /*#__PURE__*/React.createElement(UfoErrorBoundary, {
      experiences: [ufoExperiences['emoji-rendered'].getInstance(this.props.emojiId.id || this.props.emojiId.shortName)]
    }, /*#__PURE__*/React.createElement(ResourcedEmojiComponent, _extends({}, otherProps, {
      emojiProvider: loadedEmojiProvider
    })));
  }

}